export default __webpack_public_path__ + "static/media/027-drive car.5c4c7bf7.svg";